// React core
import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars

// Vendor
import cx from "classnames";

interface ISVGIconProps {
  spriteUrl?: string;
  name: string;
  className?: string;
  loading?: boolean;
}

const SVGIcon: FunctionComponent<ISVGIconProps> = ({
  name,
  className = "",
  spriteUrl = "/Content/images/v3/svg-sprite.svg",
}) => {
  return (
    <svg
      className={cx("icon", className)}
      focusable="false"
    >
      <use xlinkHref={`${spriteUrl}#${name}`} />
    </svg>
  );
};
export default SVGIcon;
